import { Component, OnInit, AfterViewInit, Input, Injector, Inject } from '@angular/core';
import { OrderService } from '../../../services/order-service';
import { AddressSimilarityResultDto, AddressServiceProxy, OrderServiceProxy, CreateOrderDto, OrderNewAddressDto, AddressDto } from '../../../../../../../../shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { AppComponentBase } from '../../../../../../../../shared/app-component-base';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

@Component({
  selector: 'kt-address-similarity-modal',
  templateUrl: './address-similarity-modal.component.html',
  styleUrls: ['./address-similarity-modal.component.scss']
})
export class AddressSimilarityModalComponent extends AppComponentBase implements OnInit {

	////Step 3 deki kaydet adres kaydetme butonundan uygun koşulda olan yerden gönderdiğimiz adres dataları.
	//@Input() addressInfo;
	//@Input() cityId: number;
	//@Input() districtId;
	//@Input() fullAddress;
	//@Input() targetCustomLocation;
	//@Input() saveOrderData: CreateOrderDto;
	//@Input() addressList;
	//@Input() criticalSimilarAddressIdList;

	selectedSimilarityAdress;

  constructor(
	  private orderService: OrderService,
	  private _orderService: OrderServiceProxy,
	  private modalService: NgbModal,
	  private customLocalization: CustomLocalizationService,
	  injector: Injector,
	  public dialogRef: MatDialogRef<AddressSimilarityModalComponent>,
	  @Inject(MAT_DIALOG_DATA)
	  public _data: any
  )
  {
	  super(injector);
  }

	ngOnInit() {
		console.log("şuan adres similarity içerisinde yim: ");
  }

	//Modal kapamak için kullanıyoruz.
  modalClose()
  {
	  this.dialogRef.close();

    //this.modalService.dismissAll();
	  
  }
	//Adres sayfasında adres eğer custom bir şekilde elle girilirse modal açıyoruz ve iki seçenek sunuyoruz.
	//Eğer kullanıcı benzer adresilerden birini radio butonlardan seçerse bu methoda sokuyoruz.
  btnChooseAddress(){

	  //if (!this.selectedSimilarityAdress) {
		 // return this.uiMessage.modal.error("", "Lütfen bir adres seçiniz", null);

		 // //return alert("Lütfen bir adres seçiniz");
	  //}
	  //this.saveOrderData.toAddressId = this.selectedSimilarityAdress.id;

	  ////Adres kaydetme işlemini yapıyoruz
	  //this.adressSaveOperation();


	  if (!this.selectedSimilarityAdress) {
		  return this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.FORMS.ADDRESSISREQUIRED"), null);

		  //return alert("Lütfen bir adres seçiniz");
	  }
	  this._data.saveOrderData.toAddressId = this.selectedSimilarityAdress.id;

	  //Adres kaydetme işlemini yapıyoruz
	  this.adressSaveOperation();

  }

		//Adres sayfasında adres eğer custom bir şekilde elle girilirse modal açıyoruz ve iki seçenek sunuyoruz.
   //Eğer benzer bir adres olmadığını ifade ederse kullanıcı, kendi yazdığı datayı ve buradan gönderiyoruz.
  btnNoAddressAffinity(){

	  //let newAddressInfo = new AddressDto();

	  //newAddressInfo.cityId = this.cityId;
	  //newAddressInfo.districtId = this.districtId;
	  //newAddressInfo.name = this.addressInfo.name;
	  //newAddressInfo.fullAddress = this.addressInfo.fullAddress;


	  //this.saveOrderData.newAddressDto = new OrderNewAddressDto({ address: newAddressInfo, isValidAddress: false });

	  //this.saveOrderData.criticalSimilarAddressIdList = this.criticalSimilarAddressIdList;

	  ////Adres kaydetme işlemini yapıyoruz
	  //this.adressSaveOperation();


	  let newAddressInfo = new AddressDto();

	  newAddressInfo.cityId = this._data.cityId;
	  newAddressInfo.districtId = this._data.districtId;
	  newAddressInfo.name = this._data.addressInfo.name;
	  newAddressInfo.fullAddress = this._data.addressInfo.fullAddress;


	  this._data.saveOrderData.newAddressDto = new OrderNewAddressDto({ address: newAddressInfo, isValidAddress: false });

	  this._data.saveOrderData.criticalSimilarAddressIdList = this._data.criticalSimilarAddressIdList;

	  //Adres kaydetme işlemini yapıyoruz
	  this.adressSaveOperation();

  }

	adressSaveOperation() {

		this.dialogRef.close(this._data.saveOrderData);

	//	this._orderService.createOrderProduct(this.saveOrderData).subscribe(data => {




	//	},
	//		err => {

	//			this.modalService.dismissAll();

	//			//return alert("Hatalı işlem" + err);
	//		},
	//		() => {
	//			this.orderService.productList = [];

	//			this.modalService.dismissAll();

	//			window.location.reload();

	//			return this.uiMessage.modal.success("", "işlem başarıyla gerçekleştirildi", null);

	//			//return alert("işlem başarıyla gerçekleştirildi");
				
	//		});
	}

}
